const { REACT_APP_KIOSK_TOKEN: KIOSK_TOKEN } = process.env;

export function hasKioskoAuthToken() {
  const token = localStorage.getItem(KIOSK_TOKEN);
  return Boolean(token);
}
